export const permissionList = [
  {
    value: 'quotation',
    label: 'Quotation',
    children: [
      { value: 'quotation.list', label: 'List', parent: true },

      // Shipping Quotation
      { value: 'quotation.view.shipping', label: 'View Shipping', groupBy: 'shipping' },
      { value: 'quotation.create.shipping', label: 'Create Shipping', groupBy: 'shipping' },
      { value: 'quotation.update.shipping', label: 'Update Shipping', groupBy: 'shipping' },
      { value: 'quotation.delete.shipping', label: 'Delete Shipping', groupBy: 'shipping' },
      { value: 'quotation.approve.shipping', label: 'Approve Shipping', groupBy: 'shipping' },

      // Trucking Quotation
      { value: 'quotation.view.trucking', label: 'View Trucking', groupBy: 'trucking' },
      { value: 'quotation.create.trucking', label: 'Create Trucking', groupBy: 'trucking' },
      { value: 'quotation.update.trucking', label: 'Update Trucking', groupBy: 'trucking' },
      { value: 'quotation.delete.trucking', label: 'Delete Trucking', groupBy: 'trucking' },
      { value: 'quotation.approve.trucking', label: 'Approve Trucking', groupBy: 'trucking' },

      // Input / Additional Permissions
      { value: 'quotation.input.baf_percentage', label: 'BAF Percentage', groupBy: 'input' },
      { value: 'quotation.create.client', label: 'Add New Client', groupBy: 'input' },
      { value: 'quotation.create.vehicle', label: 'Add New Vehicle', groupBy: 'input' },
    ],
  },

  //  Booking
  {
    value: 'booking',
    label: 'Booking',
    children: [
      { value: 'booking.list', label: 'Booking List', parent: true },
      { value: 'booking.view', label: 'View Booking' },
      { value: 'booking.create', label: 'Create Booking' },
      { value: 'booking.update', label: 'Update Booking' },
      { value: 'booking.export.shipping', label: 'Export Booking (Shipping)' },
      { value: 'booking.export.trucking', label: 'Export Booking (Trucking)' },
      { value: 'booking.export.toyota', label: 'Export Booking (Toyota)' },
    ],
  },

  //   VOF
  {
    value: 'vof',
    label: 'VOF',
    children: [
      { value: 'vof.list', label: 'VOF List', parent: true },
      { value: 'vof.view', label: 'View VOF' },
      { value: 'vof.create', label: 'Create VOF' },
      { value: 'vof.update', label: 'Update VOF' },
    ],
  },

  //   VOF
  {
    value: 'booking_item',
    label: 'Booking Item',
    children: [
      { value: 'booking_item.list', label: 'Booking Item List', parent: true },
    ],
  },

  //   VOF
  {
    value: 'trucking',
    label: 'Trucking',
    children: [
      { value: 'trucking.list', label: 'Trucking List', parent: true },
    ],
  },

  //   Shipping Order
  {
    value: 'sof',
    label: 'Shipping Order',
    children: [
      { value: 'sof.list', label: 'SOF List', parent: true },
      { value: 'sof.view', label: 'View SOF' },
      { value: 'sof.create', label: 'Create SOF' },
      { value: 'sof.update', label: 'Update SOF' },
    ],
  },

  //  Delivery Receipt
  {
    value: 'dr',
    label: 'Delivery Receipt',
    children: [
      { value: 'dr.list', label: 'DR List', parent: true },
      { value: 'dr.view', label: 'View DR' },
      { value: 'dr.create', label: 'Create DR' },
      { value: 'dr.update', label: 'Update DR' },
      { value: 'dr.print', label: 'Print Delivery Receipt' },
    ],
  },

  //  Invoice Summary
  {
    value: 'invoice',
    label: 'Invoice Summary',
    children: [
      { value: 'invoice.list', label: 'Invoice List' },
      { value: 'invoice.view', label: 'View Invoice' },
    ],
  },


  //   Vessel Setup
  {
    value: 'vessel',
    label: 'Vessel Management',
    children: [
      { value: 'vessel.list', label: 'Vessel List', parent: true },
      { value: 'vessel.view', label: 'View Vessel Specs' },
      { value: 'vessel.create', label: 'Add Vessel' },
      { value: 'vessel.update', label: 'Update Vessel' },
      { value: 'vessel.schedule', label: 'Manage Voyage Schedules' },
      { value: 'vessel.route', label: 'Manage Routes' },
    ],
  },

  //   Load/Unload Setup
  {
    value: 'load_unload',
    label: 'Load / Unload',
    children: [
      { value: 'load-and-unload.list', label: 'Load/Unload List', parent: true },
      { value: 'load-and-unload.export', label: 'Load/Unload Export' },
    ],
  },

  // //   Permission Setup
  // {
  //   value: 'permission',
  //   label: 'Permission Role Management',
  //   children: [
  //     { value: 'permission.list', label: 'Permission Role List', parent: true },
  //     { value: 'vessel.view', label: 'View Permission Role' },
  //     { value: 'vessel.create', label: 'Add Permission Role' },
  //     { value: 'vessel.update', label: 'Update Permission Role' },
  //   ],
  // },
]

export const requiredPermissions = {
  quotation: {
    tr: {
      code: 'tr',
      permissionCode: {
        create: 'quotation.create.trucking',
        update: 'quotation.update.trucking',
        view: 'quotation.view.trucking',
        delete: 'quotation.delete.trucking',
        approve: 'quotation.approve.trucking',
      }
    },
    st: {
      code: 'st',
      permissionCode: {
        create: 'quotation.create.shipping',
        update: 'quotation.update.shipping',
        view: 'quotation.view.shipping',
        delete: 'quotation.delete.shipping',
        approve: 'quotation.approve.shipping',
      }
    },
    input: {
      permissionCode: {
        baf: 'quotation.input.baf_percentage',
        addNewClient: 'quotation.create.client',
        addNewVehicle: 'quotation.create.vehicle',
      }
    },
  },
  booking: {
    code: 'booking',
    permissionCode: {
      list: 'booking.list',
      create: 'booking.create',
      update: 'booking.update',
      view: 'booking.view',
      delete: 'booking.delete',
      print: {
        st: 'booking.export.shipping',
        tr: 'booking.export.trucking',
        toyota: 'booking.export.toyota',
        all: ['booking.export.shipping', 'booking.export.trucking', 'booking.export.toyota']
      },
    }
  },
  sof: {
    code: 'sof',
    permissionCode: {
      list: 'sof.list',
      create: 'sof.create',
      update: 'sof.update',
      view: 'sof.view',
      delete: 'sof.delete',
      print: 'sof.export',
    }
  },
  dr: {
    code: 'dr',
    permissionCode: {
      list: 'dr.list',
      create: 'dr.create',
      update: 'dr.update',
      view: 'dr.view',
      delete: 'dr.delete',
      print: 'dr.export',
    }
  },
}

export const permissionRequestConfig = {
  system: 'qbs',
  request: 'permission',
  type: {
    authUserList: 'getFlattenedRolePermissionsAndUserPermissions',
    roles: {
      list: 'listRolePermission',
      create: 'createRolePermission',
      view: 'viewRolePermission',
      update: 'updateRolePermission',
      delete: 'deleteRolePermission',
    },
    user: {
      view: 'getSelectedUserRolePermissionsAndUserPermissions',
      update: 'updatePermission',
    }
  },
}
